import { ref, watch, onBeforeUnmount } from 'vue'

const pageCount = ref(null)
const pageCountLabel = ref('')

export function usePageHeader() {
  return { pageCount, pageCountLabel }
}

export function setPageHeaderCount(countRef, labelFn) {
  watch(
    countRef,
    (n) => {
      pageCount.value = n
      pageCountLabel.value = typeof labelFn === 'function' ? labelFn(n ?? 0) : ''
    },
    { immediate: true }
  )
  onBeforeUnmount(() => {
    pageCount.value = null
    pageCountLabel.value = ''
  })
}
